import { Radio, cn } from '@nextui-org/react'
import React from 'react'

const CustomRadio = ({
    description,
    value,
    children
}: {
    description: string,
    value: string,
    children: React.ReactNode
}) => {
    return (
        <div>
            <Radio
                description={description}
                value={value}
                classNames={{
                    label: cn(
                        "text-lg font-medium text-black",
                        "flex flex-col items-start justify-center"
                    ),
                    control: cn(
                        "bg-black"
                    ),
                    base: cn(
                        "inline-flex m-0 bg-content1 hover:bg-content2 items-center justify-between",
                        "flex-row-reverse w-full min-w-full cursor-pointer rounded-lg gap-4 p-4 hover:bg- bg-[#fdfcfd] hover:ring-1 ring-[#f6e05e]",
                        "data-[selected=true]:bg-[#fefae0] data-[selected=true]:ring-1 data-[selected=true]:ring-[#f6e05e]"
                    ),
                    description: cn(
                        "text-sm text-slate-700"
                    ),
                }}
            >
                {children}
            </Radio>
        </div>
    )
}

export default CustomRadio